var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"codemirror-container"}},[_c('codemirror',{ref:"cm",attrs:{"options":_vm.options},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }